import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCRASChartsDataContext } from './hooks/useIDCRASChartsDataContext';

export const HumanResourcesEvolutionChart = () => {
    const { chartData } = useIDCRASChartsDataContext();

    return (
        <SimpleBars
            title="Evolução Anual de Recursos Humanos"
            subtitles={chartData.humanResources.map((item) => getYearLabel(item.ano))}
            values={chartData.humanResources.map(
                (item) => Number(item.recursos_humanos) || 0
            )}
        />
    );
};
